var render = function render(){var _vm=this,_c=_vm._self._c;return _c('google-tag',{staticStyle:{"min-width":"320px","min-height":"50px"},attrs:{"gpt-id":_vm.gptId}})
}
var staticRenderFns = []

export { render, staticRenderFns }